window.addEventListener('load', () => {
  const mobileToggle = document.querySelector('.nav-local > button');

  mobileToggle.addEventListener('click', function() {
    const isExpanded = this.getAttribute('aria-expanded') === 'true';
    this.setAttribute('aria-expanded', !isExpanded);
  });
});

document.addEventListener('click', function() {
  const nav = document.querySelector('.nav-local');
  const mobileToggle = document.querySelector('.nav-local > button');
  if (!nav.contains(event.target)) {
    mobileToggle.setAttribute('aria-expanded', false);
  }
});
